import React, { useEffect, useState } from 'react';
import Form from 'react-bootstrap/Form';
import { Card, Col, Row } from 'react-bootstrap';
import { Link, useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BASE_URL } from '../../../services/Api';
import { authHeader } from '../../../services/auth-header';
import ITPMDConvert from '../AraiManufacturing/Convert';

function ITOPConvert() {
  const navigate = useNavigate();
  const { pointindex, id } = useParams();
  const [inspectionreporttype, setinspectionreporttype] = useState('');
  const [inspectionreportcategory, setinspectionreportcategory] = useState('');

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}inspectionReport/findById/${id}`, {
          headers: authHeader(),
        });
        setinspectionreporttype(response.data.inspectionreporttype);
        setinspectionreportcategory(response.data.inspectionreportcategory);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, [id]);

  const renderPageDisplay = () => {
    if (inspectionreporttype === 'Tubing') {
      if (inspectionreportcategory === 'Domestic') {
        // return <TDView />;
      } else if (inspectionreportcategory === 'International') {
        // return <TIView />;
      }
    } else if (inspectionreporttype === 'Pump Spare') {
      if (inspectionreportcategory === 'International') {
        // return <PIView />;
      }
    } else if (inspectionreporttype === 'Manufacturing') {
      return <ITPMDConvert />;
    }
    return null; // Default case
  };



  return (
    <div className="Container">
      <Card className="card">
        <Card.Header className="card-header">
          <h6>CONVERT INSPECTION REPORT TO PURCHASE</h6>
          <div className="view-buttons">
            <Link to={`/irindex/1`}>
              <button className="button-70">BACK</button>
            </Link>
          </div>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a Product Type:</Form.Label>
                <Form.Select disabled value={inspectionreporttype} onChange={(e) => setinspectionreporttype(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Tubing">Tubing</option>
                  <option value="Pump Spare">Pump Spare</option>
                  <option value="Manufacturing">Manufacturing</option>
                </Form.Select>
              </Form.Group>
            </Col>
            <Col md="6">
              <Form.Group>
                <Form.Label>Select a PO Category:</Form.Label>
                <Form.Select disabled value={inspectionreportcategory} onChange={(e) => setinspectionreportcategory(e.target.value)}>
                  <option value="">--Please choose an option--</option>
                  <option value="Domestic">Domestic</option>
                  <option value="International">International</option>
                </Form.Select>
              </Form.Group>
            </Col>
            {renderPageDisplay()}
          </Row>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ITOPConvert;
